module.exports = __webpack_public_path__ + "images/emoji/man.06ef89fb0ce1139eccde.png";